import { inject } from "vue";
import { buildUrlPrefix } from "@shopware-pwa/helpers-next";

export function useUrlResolver() {
  const getUrlPrefix = () => inject("urlPrefix", "");

  const resolveUrl = (input: unknown): string => {
    // normalize to string
    let url = "";
    if (typeof input === "string") url = input;
    else if (input && typeof (input as any).url === "string") url = (input as any).url as string;
    else if (input && typeof (input as any).href === "string") url = (input as any).href as string;
    else return "";

    // @see: https://codeql.github.com/codeql-query-help/javascript/js-polynomial-redos/
    if (url.length > 2083) {
      throw new Error("URL Input too long");
    }

    const navigationPattern = /[a-zA-Z0-9]+\/navigation\/[a-zA-Z0-9]+/;
    const urlPrefix = getUrlPrefix();

    const mediaIdMatch = url.match(/\/mediaId\/([a-f0-9-]+)/i);
    if (mediaIdMatch?.[1]) {
      const mediaId = mediaIdMatch[1];

      return `/api/media/${mediaId}`;
    }

    if (navigationPattern.test(url)) {
      const newUrl = url.split("/").slice(1);

      if (newUrl.length > 0) {
        return `${buildUrlPrefix(newUrl.join("/"), urlPrefix)}`;
      }
    }

    return url;
  };

  return {
    resolveUrl,
    getUrlPrefix,
  };
}
